module.exports = __webpack_public_path__ + "img/payslip_desc.b100efc8.png";